import {Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {IObservation} from '../../../message-models/observation.interface';
import {IDocument} from '../../../message-models/document.interface';
import {ICompanyInfo} from '../../../message-models/company-info.interface';
import {IJobTitleInfo} from '../../../message-models/job-title.interface';
import {ListDataService} from '../../../services/list-data.service';
import {IAlertInfo} from '../../../alerts/models/IAlertInfo.interface';
import {IModalOptions} from '../../../common/modals/modal-options.interface';
import {CompanyDocumentService} from '../../services/company-documents.service';
import {ICompanyDocumentSummary} from '../../../message-models/company-document-summary.interface';
import {Router} from '@angular/router';
import {DocumentService} from '../../../documents/services/document.service';
import {DocumentModalService} from '../../../documents/services/document-modal.service';
import {IEntityDocumentSummary} from '../../../message-models/entity-document-summary';
import {DocumentEntityType} from '../../../message-models/document-entity-type.enum';
import {IRiskInfo} from '../../../message-models/risk-info.interface';
import {IJobLevelInfo} from '../../../message-models/job-level.interface';
import {IRiskMatrixEntry} from '../../../message-models/risk-matrix-entry.interface';
import {OperativeInfo} from '../../../domain-model/operative-info.class';
import {OperativesService} from '../../../operatives/services/operatives.service';
import {CompanyService} from '../../services/company.service';
import {CompanyInfo} from '../../../domain-model/company-info.class';
import {IDocumentSummaryInfo} from '../../../message-models/document-summary-info.interface';
import {IObservationSummary} from '../../../message-models/observation-summary.interface';
import {ObservationsService} from '../../../observations/services/observations.service';
import {Observation, ObservationType, ObservationTypeString} from 'src/app/domain-model/observation.class';
import {ObservationModalService} from '../../../observations/services/observation-modal.service';
import {DashboardCardComponent} from '../../../common/components/dashboard-card/dashboard-card.component';
import {DashboardCard, IDashboardCard} from '../../../common/modals/dashboard-card.class';
import {OperativeModalService} from '../../../operatives/services/operative-modal.service';
import {ExtendedJobLevel} from '../../../message-models/extended-job-level.class';
import {ExtendedRiskInfo} from '../../../message-models/extended-risk-info.class';
import {CompanyDashboardStateService} from '../../services/company-dashboard-state.service';
import {OurUserService} from '../../../users/services/user.service';
import {IUserInfo} from '../../../users/models/userInfo.interface';
import {RiskHelpModalService} from '../../../services/risk-help-modal.service';
import {IBreadcrumb} from '../../../eca-breadcrumb/models/breadcrumb.interface';
import {EcaBreadcrumbService} from '../../../eca-breadcrumb/services/eca-breadcrumb.service';
import {EcaConfirmProcessService} from '../../../shared/services/eca-confirm-process.service';
import {EcaConfirmDeleteModalOptions} from '../../../shared/models/confirm-delete-modal-options.class';
import {ErrorHandlingService} from '../../../services/error-handling.service';
import {AlertsService} from '../../../alerts/services/alerts.service';
import {HelpConsts} from '../../../help/models/help-consts';
import {HelpModalService} from '../../../help/services/help-modal.service';
import {IEmploymentStatus} from '../../../message-models/employment-status.interface';
import { IOperativeTypeInfo } from '../../../message-models/operative-type.interface';
import { ObservationSummary } from '../../../domain-model/observation-summary';
import { IBusinessUnitInfo } from '../../../message-models/business-unit.interface';
import { ICompanyJobTitle } from '../../../message-models/company-job-title.interface';
import { CompanyJobRoleService } from '../../../setting/job-role/services/company-job-role.service';
import { consts } from '../../../common/modals/consts';

@Component({
  selector: 'app-company-dashboard',
  templateUrl: './company-dashboard.component.html',
  styleUrls: ['./company-dashboard.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class CompanyDashboardComponent implements OnInit, OnDestroy {
  @ViewChild('compDetailCard') compDetailCard: DashboardCardComponent;

  alerts: IAlertInfo[];
  recentObservations: Array<IObservationSummary>;
  selectedObservation: Observation = new Observation({} as IObservation);
  ObservationType: typeof ObservationType = ObservationType;
  ObservationTypeString: typeof ObservationTypeString = ObservationTypeString;
  allRisks: IRiskInfo[];
  allEmploymentStatuses: IEmploymentStatus[];
  allJobLevels: IJobLevelInfo[];
  riskMatrix: IRiskMatrixEntry[];
  operatives: OperativeInfo[];
  selectedOperativeId: string;
  selectedDocumentId: string;
  selectedTrainingRecordId: string;
  observationModalHeading: string;
  entityObservationId: string;
  observations: IObservation[];
  documents: IDocument[];
  company: CompanyInfo = new CompanyInfo({} as ICompanyInfo);
  companyDocuments: Array<ICompanyDocumentSummary>;
  companyId = '';
  isTrialCompany: boolean;
  jobTitles: IJobTitleInfo[];
  allCompanyJobTitles: ICompanyJobTitle[] = [];
  selectedCompanyJobTitle: ICompanyJobTitle;
  allOperativeTypes: IOperativeTypeInfo[];
  allBusinessUnits: IBusinessUnitInfo[];
  loading: boolean;

  loadingOperatives: boolean = true;
  documentsLoading: boolean = true;
  loadingObservations: boolean = true;
  loadingCompanyDetails: boolean = true;
  editingCompanyDetails: boolean = false;
  private originalCompany: CompanyInfo;
  companyDocumentSummaries: IDocumentSummaryInfo[];
  companyDetailsCard: DashboardCard;
  operativesListCard: DashboardCard;
  recentObservationsListCard: DashboardCard;
  recentDocumentsCard: DashboardCard;
  loggedInUser: IUserInfo;

  constructor(private confirmProcessService: EcaConfirmProcessService,
              private companyService: CompanyService,
              private operativesService: OperativesService,
              private companyDocumentService: CompanyDocumentService,
              private documentService: DocumentService,
              private documentModalService: DocumentModalService,
              private listDataService: ListDataService,
              private observationsService: ObservationsService,
              private observationModalService: ObservationModalService,
              private operativeModalService: OperativeModalService,
              private helpService: HelpModalService,
              private companyDashboardStateService: CompanyDashboardStateService,
              private router: Router, private userService: OurUserService,
              private riskHelpModalService: RiskHelpModalService,
              private alertsService: AlertsService,
              private errorHandlingService: ErrorHandlingService,
              private companyJobRoleService: CompanyJobRoleService,
              private ecaBreadcrumbService: EcaBreadcrumbService) {

  }

  setCompanyDashboardCards() {
    this.companyDetailsCard = new DashboardCard({ headerClass: 'eca-secondary-bg'} as IDashboardCard);
    this.operativesListCard = new DashboardCard({ headerClass: 'eca-secondary-bg'} as IDashboardCard);
    this.recentObservationsListCard = new DashboardCard({ headerClass: 'eca-secondary-bg'} as IDashboardCard);
    this.recentDocumentsCard = new DashboardCard({ headerClass: 'eca-secondary-bg'} as IDashboardCard);
  }

  ngOnDestroy() {
    this.companyDashboardStateService
      .setDashboardState(this.companyDetailsCard, this.operativesListCard, this.recentObservationsListCard, this.recentDocumentsCard);
  }


  ngOnInit(): void {
    this.userService.getLoggedInUser().subscribe(user => {
      this.loggedInUser = user;
      this.companyId = this.loggedInUser?.companyId;
      this.companyService.getCompany(this.companyId).subscribe(company => {
        if (company.trialValidTo != null) {
          this.isTrialCompany = true;
        }
      })
      this.initDashboard();
      this.populateBreadcrumbs();
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });

  }

  initDashboardCards() {
    if (this.companyDashboardStateService.cardsSet) {
      this.recentDocumentsCard = new DashboardCard(this.companyDashboardStateService.getRecentDocumentsCard());
      this.companyDetailsCard = new DashboardCard(this.companyDashboardStateService.getCompanyDetailsCard());
      this.operativesListCard = new DashboardCard(this.companyDashboardStateService.getOperativesListCard());
      this.recentObservationsListCard = new DashboardCard(this.companyDashboardStateService.getRecentObservationsListCard());
    } else {
      this.setCompanyDashboardCards();
    }
  }

  initDashboard() {
    this.initDashboardCards();
    this.companyService.getCompany(this.companyId).subscribe(company => {
      this.company = new CompanyInfo(company);
      this.loadingCompanyDetails = false;
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });

    this.listDataService.getAllJobTitles().subscribe({
      next: response => {
        this.jobTitles = response;
      },
      error: () => {
        this.errorHandlingService.showErrorWarning().subscribe(() => {
        });
      }
    });

    this.companyJobRoleService.getCompanyJobTitlesByCompanyId(this.companyId).subscribe({
      next: response => {
        this.allCompanyJobTitles = response;
      },
      error: () => {
        this.errorHandlingService.showErrorWarning().subscribe(() => {
        });
      }
    });



    this.listDataService.getAllOperativeTypes().subscribe({
      next: response => {
        this.allOperativeTypes = response;
      },
      error: () => {
        this.errorHandlingService.showErrorWarning().subscribe(() => {
        });
      }
    });

    this.listDataService.getBusinessUnitsForCompany(this.companyId).subscribe({
      next: response => {
        this.allBusinessUnits = response;
      },
      error: () => {
        this.errorHandlingService.showErrorWarning().subscribe(() => {
        });
      }
    });

    this.observationsService.getRecentObservationsForCompany(this.companyId).subscribe(recentObservationSummaries => {
      this.recentObservations = recentObservationSummaries;
      this.loadingObservations = false;

    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });

    this.getCompanyDocumentSummaries();
    this.loadOperatives();

    this.listDataService.getAllRisks().subscribe({
      next: response => {
        this.allRisks = response;
        this.operativesService.setOperativeRisks(response);
      },
      error: () => {
        this.errorHandlingService.showErrorWarning().subscribe(() => {
        });
      }
    });

    this.listDataService.getAllEmploymentStatuses().subscribe({
      next: response => {
        this.allEmploymentStatuses = response;
        this.operativesService.setOperativeEmploymentStatus(response);
      },
      error: () => {
        this.errorHandlingService.showErrorWarning().subscribe(() => {
        });
      }
    });

    this.listDataService.getAllJobLevels().subscribe({
      next: response => {
        this.allJobLevels = response;
        this.operativesService.setOperativeJobLevels(response);
      },
      error: () => {
        this.errorHandlingService.showErrorWarning().subscribe(() => {
        });
      }
    });    

    this.listDataService.getRiskMatrix().subscribe({
      next: response => {
        this.riskMatrix = response;
        this.operativesService.setOperativeRiskMatrixLevels(response);
      },
      error: () => {
        this.errorHandlingService.showErrorWarning().subscribe(() => {
        });
      }
    });
  }

  private populateBreadcrumbs() {
    const operativeBreadCrumbs = new Array<IBreadcrumb>();
    this.ecaBreadcrumbService.breadCrumbs.next(operativeBreadCrumbs);
  }

  private loadOperatives() {
    this.operativesService.getOperativesInCompany(this.companyId, new Date().toISOString()).subscribe({
      next: operatives => {
        this.operatives = operatives;
        if (this.jobTitles) {
          this.operatives.forEach(op => {
            if (op.currentOperativeTypeId == "4eff2451-6793-4590-82c1-fc189dc47859") {             
              op.jobTitle = this.allCompanyJobTitles.find(x => x.id === op.currentJobTitleId)?.name;
            }
            else {
              op.jobTitle = this.jobTitles.find(x => x.id === op.currentJobTitleId)?.name;
            }
            op.totalCPDHours = op.trainingRecords.filter(record => record.cpdHour > 0).reduce((acc, record) => acc + record.cpdHour, 0);
          });
        }
        if (this.allOperativeTypes) {
          this.operatives.forEach(op => {
            op.operativeType = this.allOperativeTypes.find(x => x.id === op.currentOperativeTypeId).name;
            op.totalCPDHours = op.trainingRecords.filter(record => record.cpdHour > 0).reduce((acc, record) => acc + record.cpdHour, 0);
            op.totalCPDHours = parseFloat(op.totalCPDHours.toFixed(2));
          });
        }
        if (this.allBusinessUnits) {
          this.operatives.forEach(op => {
            op.businessUnit = this.allBusinessUnits.length > 0 ? this.allBusinessUnits.find(x => x.id === op.currentBusinessUnitId)?.name : "";
          });
        }
        this.operativesService.setOperativeRiskAndLevels(this.allRisks, this.allJobLevels, this.riskMatrix, this.allEmploymentStatuses);
      },
      error: () => {
        this.errorHandlingService.showErrorWarning().subscribe(() => {
        });
      },
      complete: () => this.loadingOperatives = false
    });
  }

  getCompanyDocumentSummaries(includeExpired: boolean = false) {
    this.companyDocumentService.getAllDocumentSummariesByEntityType(this.companyId, null, includeExpired).subscribe(companyDocuments => {
      this.companyDocumentSummaries = companyDocuments;
      this.documentsLoading = false;
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });
  }

  downloadCompanyDocument(documentSummaryInfo: IDocumentSummaryInfo) {
    this.documentService.downloadOrOpenDocument(documentSummaryInfo, true);
  }

  openCompanyDocument(documentSummaryInfo: IDocumentSummaryInfo) {
    this.documentService.downloadOrOpenDocument(documentSummaryInfo);
  }

  deleteCompanyDocumentClick(companyDocument: IEntityDocumentSummary) {
    this.confirmProcessService.openConfirmProcessModal('Are you sure you want to delete this document?', 'Delete ' + companyDocument.originalFilename, new EcaConfirmDeleteModalOptions()).subscribe({
      next: response => {
        if (response) {
          this.documentsLoading = true;
          this.deleteCompanyDocument(companyDocument);
        }
      },
      error: () => {
        this.errorHandlingService.showErrorWarning().subscribe(() => {
        });
      }
    });
  }

  deleteCompanyDocument(companyDocument: IEntityDocumentSummary) {
    this.companyDocumentService.deleteCompanyDocument(companyDocument.documentId, this.companyId).subscribe(
      result => {
        if (result) {
          this.getCompanyDocumentSummaries();
          this.documentsLoading = false;
          this.alertsService.getAlertsCountForCompany(this.loggedInUser?.companyId).subscribe();

        }
      }, () => {
        this.errorHandlingService.showErrorWarning().subscribe(() => {
        });
      });
  }

  addCompanyDocument() {
    this.documentModalService.openDocumentUploaderModal(null, DocumentEntityType.company, 'Add Document').subscribe(documentModalRef => {
      documentModalRef.content.documentUploadSave.subscribe((documentUploadRequest: FormData) => {
        documentModalRef.dynamicDialogRef.close();
        documentUploadRequest.append('CompanyId', this.companyId);
        this.loading = true;
        this.documentsLoading = true;
        this.companyDocumentService.createOrUpdateCompanyDocument(documentUploadRequest).subscribe(companyDocumentSummary => {
          this.loading = false;
          this.documentsLoading = false;
          this.getCompanyDocumentSummaries();
          this.alertsService.getAlertsCountForCompany(this.loggedInUser?.companyId).subscribe();
        }, () => {
          this.errorHandlingService.showErrorWarning().subscribe(() => {
          });
        });
      });
    });
  }

  editCompanyDocument(companyDocumentSummary: IEntityDocumentSummary) {
    this.documentModalService.openDocumentUploaderModal(companyDocumentSummary, DocumentEntityType.company, 'Edit Document').subscribe(documentModalRef => {
      documentModalRef.content.documentUploadSave.subscribe((documentUploadRequest: FormData) => {
        documentModalRef.dynamicDialogRef.close();
        this.documentsLoading = true;
        documentUploadRequest.append('CompanyId', this.companyId);
        this.loading = true;
        this.companyDocumentService.createOrUpdateCompanyDocument(documentUploadRequest).subscribe(updatedCompanyDocumentSummary => {
          this.loading = false;
          this.documentsLoading = false;
          this.getCompanyDocumentSummaries();
          this.loading = false;
          this.documentsLoading = false;
          this.alertsService.getAlertsCountForCompany(this.loggedInUser?.companyId).subscribe();
        }, () => {
          this.errorHandlingService.showErrorWarning().subscribe(() => {
          });
        });
      });
    });
  }

  editCompanyDetails() {
    if (this.companyDetailsCard.isCollapsed) {
      this.compDetailCard.panelToggle();
    }
    this.originalCompany = new CompanyInfo(this.company);
    this.editingCompanyDetails = true;
  }

  cancelEditCompanyDetails() {
    this.company = new CompanyInfo(this.originalCompany);
    this.editingCompanyDetails = false;
  }

  saveCompanyDetails() {
    this.editingCompanyDetails = false;
    this.companyService.updateCompany(this.company).subscribe(result => {
      this.company = new CompanyInfo(result);
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });
  }

  //viewObservation(observationId: string, isEditing: boolean = false, isNew?: boolean) {
  //  this.recentObservations.forEach(opObservation => {
  //    if (opObservation.observationId === observationId) {
  //      this.observationModalHeading = '';
  //      this.selectedOperativeId = opObservation.operativeId;
  //      this.selectedObservation.id = observationId;
  //      this.selectedObservation.summaryInfo = opObservation.summaryInfo;
  //      this.selectedObservation.followUpOn = opObservation.followUpOn;
  //      this.selectedObservation.observationType = opObservation.observationType;
  //      this.selectedObservation.observedOn = opObservation.observedOn;
  //      this.selectedObservation.observedBy = opObservation.observedBy;
  //      this.selectedObservation.notesAsHtml = opObservation.notesAsHtml;
  //      switch (opObservation.observationType) {
  //        case  ObservationType.Operative: {
  //          this.entityObservationId = opObservation.operativeObservationId;
  //          this.observationModalHeading = 'Observation of ' + opObservation?.operativeName;
  //          break;
  //        }
  //        case ObservationType.CompanyDocument: {
  //          this.entityObservationId = opObservation.documentObservationId;
  //          this.selectedDocumentId = opObservation.documentId;
  //          this.observationModalHeading = 'Observation of ' + opObservation?.companyName;
  //          break;
  //        }
  //        case ObservationType.OperativeDocument:
  //        case ObservationType.TrainingRecordDocument : {
  //          this.entityObservationId = opObservation.documentObservationId;
  //          this.selectedDocumentId = opObservation.documentId;
  //          this.observationModalHeading = 'Observation of ' + opObservation?.operativeName;
  //          break;
  //        }
  //        case ObservationType.TrainingRecord: {
  //          this.entityObservationId = opObservation.trainingRecordObservationId;
  //          this.selectedTrainingRecordId = opObservation.trainingRecordId;
  //          this.observationModalHeading = 'Observation of ' + opObservation?.operativeName;
  //          break;
  //        }
  //        case ObservationType.Company: {
  //          this.entityObservationId = opObservation.companyObservationId;
  //          this.observationModalHeading = 'Observation of ' + opObservation?.companyName;
  //          break;
  //        }
  //      }
  //    }
  //  });
  //  this.observationModalService.createOrEditObservation(this.selectedObservation, this.observationModalHeading, false).subscribe(observationModalRef => {
  //    observationModalRef.content.saveObservationClicked.subscribe(observationResult => {
  //      if (observationResult !== null) {
  //        observationModalRef.dynamicDialogRef.close();
  //        switch (observationResult.observationType) {
  //          case  ObservationType.Operative: {
  //            this.loadingObservations = true;
  //            this.observationsService.createOrUpdateOperativeObservation(observationResult, this.selectedOperativeId, this.companyId, this.entityObservationId).subscribe(operativeObservation => {
  //              this.recentObservations = this.observationsService.updateObservationSummaries(this.recentObservations, operativeObservation);
  //              this.alertsService.getAlertsCountForCompany(this.loggedInUser?.companyId).subscribe();

  //              this.loadingObservations = false;
  //            }, () => {
  //              this.errorHandlingService.showErrorWarning().subscribe(() => {
  //              });
  //            });
  //            break;
  //          }
  //          case ObservationType.OperativeDocument:
  //          case ObservationType.TrainingRecordDocument :
  //          case ObservationType.CompanyDocument: {
  //            this.loadingObservations = true;
  //            this.observationsService.createOrUpdateDocumentObservation(observationResult, this.selectedDocumentId, this.companyId, this.entityObservationId).subscribe(documentObservation => {
  //              this.recentObservations = this.observationsService.updateObservationSummaries(this.recentObservations, documentObservation);
  //              this.alertsService.getAlertsCountForCompany(this.loggedInUser?.companyId).subscribe();
  //              this.loadingObservations = false;
  //            }, () => {
  //              this.errorHandlingService.showErrorWarning().subscribe(() => {
  //              });
  //            });
  //            break;
  //          }
  //          case ObservationType.TrainingRecord: {
  //            this.loadingObservations = true;
  //            this.observationsService.createOrUpdateTrainingRecordObservation(observationResult, this.selectedTrainingRecordId, this.companyId, this.entityObservationId).subscribe(trainingRecordObservation => {
  //              this.recentObservations = this.observationsService.updateObservationSummaries(this.recentObservations, trainingRecordObservation);
  //              this.alertsService.getAlertsCountForCompany(this.loggedInUser?.companyId).subscribe();
  //              this.loadingObservations = false;
  //            }, () => {
  //              this.errorHandlingService.showErrorWarning().subscribe(() => {
  //              });
  //            });
  //            break;
  //          }
  //          case ObservationType.Company: {
  //            this.loadingObservations = true;
  //            this.observationsService.createOrUpdateCompanyObservation(observationResult, this.companyId, this.entityObservationId).subscribe(companyObservation => {
  //              this.recentObservations = this.observationsService.updateObservationSummaries(this.recentObservations, companyObservation);
  //              this.alertsService.getAlertsCountForCompany(this.loggedInUser?.companyId).subscribe();
  //              this.loadingObservations = false;
  //            }, () => {
  //              this.errorHandlingService.showErrorWarning().subscribe(() => {
  //              });
  //            });
  //            break;
  //          }
  //        }


  //      }

  //    });
  //  });
  //}

  viewObservation(iObservationSummary?: IObservationSummary) {
    let observationSummary = new ObservationSummary(iObservationSummary);
    this.router.navigate(["/observation-details/" + observationSummary.observationId])
  }


  //editObservation(observationId: string) {
  //  this.viewObservation(observationId, true);
  //}

  deleteObservation(observationId: string) {
    let observation: IObservationSummary;
    this.recentObservations.forEach(observationSummary => {
      if (observationSummary.observationId === observationId) {
        observation = observationSummary;
      }
    });
    this.confirmProcessService.openConfirmProcessModal('Are you sure you want to delete this observation?',
      'Delete ', new EcaConfirmDeleteModalOptions()).subscribe({
      next: response => {
        if (response) {
          this.loadingObservations = true;
          this.observationsService.deleteObservation(observation.observationId, observation.observationType, this.companyId).subscribe(result => {
            if (result) {
              this.recentObservations.forEach(x => {
                if (x.observationId === observation.observationId) {
                  this.recentObservations = this.recentObservations.filter(d => d.observationId !== observation.observationId);
                }
              });
              this.alertsService.getAlertsCountForCompany(this.loggedInUser?.companyId).subscribe();
              this.loadingObservations = false;
            }
          }, () => {
            this.errorHandlingService.showErrorWarning().subscribe(() => {
            });
          });
        }
      }
    });
  }

  //createCompanyObservation() {
  //  this.observationModalHeading = 'Observation for ' + this.company.companyName;
  //  this.selectedObservation = new Observation({} as IObservation);
  //  this.observationModalService.createOrEditObservation(this.selectedObservation, this.observationModalHeading, true, ObservationType.Company).subscribe(observationModalRef => {
  //    observationModalRef.content.saveObservationClicked.subscribe(observationResult => {
  //      if (observationResult !== null) {
  //        observationResult.observationType = ObservationType.Company;
  //        this.loadingObservations = true;
  //        this.observationsService.createOrUpdateCompanyObservation(observationResult, this.companyId).subscribe(companyObservation => {
  //          this.recentObservations = this.observationsService.updateObservationSummaries(this.recentObservations, companyObservation, this.company.companyName);
  //          this.loadingObservations = false;
  //          this.alertsService.getAlertsCountForCompany(this.loggedInUser?.companyId).subscribe();
  //        }, () => {
  //          this.errorHandlingService.showErrorWarning().subscribe(() => {
  //          });
  //        });
  //        observationModalRef.dynamicDialogRef.close();
  //      }
  //    });
  //  });
  //}

  goToCompanyObservations() {
    this.router.navigate(['/company-observations']);
  }

  goToOperativeObservations() {
    this.router.navigate(['/operative-observations']);
  }

  gotoOperativesPage() {
    this.router.navigate(['/operatives']);
  }

  addOperative() {
    const newOperative = new OperativeInfo();
    newOperative.companyId = this.company.id;

    newOperative.currentBusinessUnitId = consts.emptyGuid;
    const defaultEmploymentStatus = this.allEmploymentStatuses.find(s => s.isDefault);
    newOperative.currentEmploymentStatusId = defaultEmploymentStatus?.id;

    const jobLevels: ExtendedJobLevel[] = [];
    this.allJobLevels.forEach(l => {
      jobLevels.push(new ExtendedJobLevel(l));
    });

    const risks: ExtendedRiskInfo[] = [];
    this.allRisks.forEach(r => {
      risks.push(new ExtendedRiskInfo(r));
    });
 
    this.operativeModalService.openOperativeEditorModal(newOperative, 'Add a New Operative',
      this.jobTitles, this.allCompanyJobTitles, jobLevels, risks, this.allEmploymentStatuses, this.allOperativeTypes, this.allBusinessUnits, true).subscribe(modalRef => {
      modalRef.content.saveOperativeRequested.subscribe(operative => {
        if (operative) {
          this.loadingOperatives = true;
          this.operativesService.createOrUpdateOperative(operative).subscribe(result => {
            if (result) {
              this.loadOperatives();
              this.loadingOperatives = false;
            }
          }, (error) => {
            console.log(error);
            this.errorHandlingService.showErrorWarning().subscribe(() => {
            });
          });
        }
      });
    });
  }

  openRiskHelp() {
    this.riskHelpModalService.openRiskHelpModal('Help', this.riskMatrix, this.allRisks, this.allJobLevels, this.operatives, null, '', this.loggedInUser?.companyName, false);
  }

  openCompanyHelp() {
    this.helpService.openHelpModal(HelpConsts.CompanyDetailsHelp);

  }

  openOperativesHelp() {
    this.helpService.openHelpModal(HelpConsts.DashboardOperativesListHelp);
  }

  openObservationsHelp() {
    this.helpService.openHelpModal(HelpConsts.RecentObservationsList);
  }

  openRecentDocumentsHelp() {
    this.helpService.openHelpModal(HelpConsts.RecentDocumentsList);
  }
}

export class DangerAlertModalOptions implements IModalOptions {
  modalClasses = 'modal-danger';
  noButtonColour = 'danger';
  noButtonIcon = 'fas fa-times';
  noButtonText = 'Dismiss';
  yesButtonColour = 'warning';
  yesButtonIcon = 'fas fa-check';
  yesButtonText = 'Remind Me Later';
  editButtonIcon = 'fas fa-edit';
}

export class WarningAlertModalOptions implements IModalOptions {
  modalClasses = 'modal-warning';
  noButtonColour = 'danger';
  noButtonIcon = 'fas fa-times';
  noButtonText = 'Dismiss';
  yesButtonColour = 'warning';
  yesButtonIcon = 'fas fa-check';
  yesButtonText = 'Remind Me Later';
  editButtonIcon = 'fas fa-edit';
}
